import { SearcherWithComposedCode } from "components/input/searcherWithCode/searcherWithComposedCode/searcherWithComposedCode";
import { OptionHolder, SearcherParameter } from "components/input/select/options";

export function mergeOptions(queryParameters, options: OptionHolder): any {

    SearcherWithComposedCode.cleanupOptions(options);

    if (options == null) {
        return {
            isOptionsChanged: false,
            queryParameters,
        };
    }
    let isOptionsChanged = false;
    const queryParametersObject = {};
    const optionsObject = {};
    for (const queryParameter of queryParameters) {
        queryParametersObject[queryParameter.property] = queryParameter.value;
    }
    for (const option of options as SearcherParameter[]) {
        optionsObject[option.property] = option.value;
    }

    for (const qpKey in queryParametersObject) {
        if (Object.keys(optionsObject).includes(qpKey)) {
            if (different(queryParametersObject[qpKey], optionsObject[qpKey])) {
                isOptionsChanged = true;
            }
            if (optionsObject[qpKey] == null) {
                delete queryParametersObject[qpKey];
            } else {
                queryParametersObject[qpKey] = optionsObject[qpKey];
            }
            delete optionsObject[qpKey];
        }
    }

    // tslint:disable-next-line: forin
    for (const ooKey in optionsObject) {
        if (different(queryParametersObject[ooKey], optionsObject[ooKey])) {
            isOptionsChanged = true;
        }
        if (optionsObject[ooKey] == null) {
            delete queryParametersObject[ooKey];
        } else {
            queryParametersObject[ooKey] = optionsObject[ooKey];
        }
    }

    queryParameters.length = 0;

    // tslint:disable-next-line: forin
    for (const qpKey in queryParametersObject) {
        queryParameters.push({
            property: qpKey,
            value: queryParametersObject[qpKey]
        });
    }
    return {
        isOptionsChanged,
        queryParameters,
    };
}

function different(a, b) {
    return (a !== b) ||
        (a == null && b != null) ||
        (a != null && b == null);
}
